<header>
  <nav [ngClass]="setBackground() + ' ' + setShadow()">
    <div class="container p-5 mx-auto">
      <div class="flex items-center justify-between">

        <!-- right side -->
        <div class="flex space-x-4">

          <!-- logo image -->
          @if (!isAdmin) {
            <a routerLink=""><img class="w-36" alt="AngolaEncontra" [src]="setLogoSource()"/></a>
          }

          <!-- admin side navigator toggler -->
          @if (isAdmin) {
            <div class="flex items-center">
              <div (click)="toggleSideNav()" class="cursor-pointer lg:hidden">
                <i class="pi pi-bars" [ngClass]="setTextColor()" style="font-size: 1rem"></i>
              </div>
              <div  class=" ml-4">
                <span class="hidden md:inline-block">Bem-vindo </span> <span class="bg-orange-50 p-1"> {{loggedUserName}} </span>
              </div>
            </div>
          }

          @if (!isAdmin) {
<div [ngClass]="setTextColor()" class="hidden md:flex md:items-center md:mx-0 md:py-0
              space-x-4">
            <a routerLink="ocorrencias" [queryParams]="{padrao:'people'}" class="text-sm font-medium
                    transition-colors duration-200 hover:text-amber-500 md:mx-2">Pessoas</a>
            <a routerLink="ocorrencias" [queryParams]="{padrao:'document'}" class="text-sm font-medium
                    transition-colors duration-200 hover:text-amber-500 md:mx-2">Documentos</a>
            <a routerLink="ocorrencias" [queryParams]="{padrao:'vehicle'}" class="text-sm font-medium
                    transition-colors duration-200 hover:text-amber-500 md:mx-2">Veículos</a>
            <a routerLink="ocorrencias" [queryParams]="{padrao:'other'}" class="text-sm font-medium
                    transition-colors duration-200 hover:text-amber-500 md:mx-2">Diversos</a>
            </div>
          }
        </div>

        <!-- left side -->
        <div class="hidden md:flex md:items-center">

          <app-custom-button class="mx-2" label="Criar ocorrência" icon="pi pi-plus" link="/criar"
                             [transparent]="true" [onLight]="isLightNav" size="sm"></app-custom-button>

          <!-- not authenticated -->
          @if (!isAuthenticated()) {
            <a href="" (click)="$event.preventDefault(); navigateTo('/acesso')"
               class="flex items-center space-x-1 z-10 p-2 py-1 text-sm font-medium
                    transition-colors duration-200 hover:text-amber-500 cursor-pointer"
              [ngClass]="setTextColor()">
              <span>Conta</span>
            </a>
          } @else {
            <a routerLink="/perfil" class="z-10" aria-label="Perfil">
              <app-profile-view [user]="user"></app-profile-view>
            </a>
          }

          <!-- authenticated -->
        </div>

        <!-- full menu for small screeen -->
        <div class="flex items-center md:hidden">
          @if (isAuthenticated()) {
            <a routerLink="/perfil" aria-label="Perfil">
              <app-profile-view [user]="user"></app-profile-view>
            </a>
          }
          <div (click)="menuComplete.toggle($event)" class="cursor-pointer">
            <i class="pi pi-bars" [ngClass]="isLightNav ? 'text-red' : 'text-white'"
               style="font-size: 1.5rem"></i>
          </div>
        </div>

      </div>

    </div>
  </nav>
</header>

<p-menu #menuComplete [model]="menuCompleteItems" [popup]="true"></p-menu>
